"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

exports.__esModule = true;
exports.default = void 0;
var carouselDefaults = {
  arrowBg: 'white',
  arrowBorderRadius: 0,
  arrowOpacity: '0.6',
  arrowPadding: 'base',
  arrowStrokeColor: 'black',
  shadowBackgroundRGB: '255, 255, 255',
  iconTransform: 'rotate(-90deg)'
};
var carousel = {
  ascential: _objectSpread(_objectSpread({}, carouselDefaults), {}, {
    arrowBg: 'accent1',
    arrowBorderRadius: '50%',
    arrowOpacity: '1',
    arrowPadding: 'xsmall',
    arrowStrokeColor: 'white'
  }),
  horizon: _objectSpread({}, carouselDefaults),
  cannesLions: _objectSpread({}, carouselDefaults),
  lionsCreativity: _objectSpread(_objectSpread({}, carouselDefaults), {}, {
    shadowBackgroundRGB: '244, 244, 244',
    arrowBorderRadius: '60%',
    arrowPadding: 'none',
    arrowBg: 'none',
    arrowStrokeColor: 'black',
    arrowOpacity: '0.5',
    iconTransform: 'rotate(-90deg) translate(0, 2px)'
  }),
  lionsLive: _objectSpread(_objectSpread({}, carouselDefaults), {}, {
    arrowBg: 'secondary',
    arrowOpacity: '1'
  }),
  money2020: _objectSpread({}, carouselDefaults),
  dcl: _objectSpread(_objectSpread({}, carouselDefaults), {}, {
    arrowBg: 'greymid'
  })
};
var _default = carousel;
exports.default = _default;